import type { PropsWithChildren } from 'react'

interface AuthLayoutProps extends PropsWithChildren {
  imageClass: string
}

export const AuthLayout = ({ children, imageClass }: AuthLayoutProps) => {
  return (
    <div className="w-screen min-h-screen bg-muted grid place-items-center">
      <div className="flex rounded-3xl overflow-hidden border border-muted-foreground/50">
        <div className={`w-140 h-165 bg-cover bg-center ${imageClass}`}></div>
        <div className="w-165 h-165 bg-background shadow-2xl border-l border-muted-foreground/50">
          {children}
        </div>
      </div>
    </div>
  )
}
